import { Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { RequiredPermissionDirective } from '@app/core/directives/required-permission.directive';

@Component({
    selector: 'inspekt-material-button',
    templateUrl: './material-button.component.html',
    styleUrls: ['./material-button.component.css'],
    imports: [MatButtonModule, MatMenuModule, MatIconModule, RequiredPermissionDirective]
})
export class MaterialButtonComponent {
    readonly data = input<any>();

}
